import { RiStockFill } from "react-icons/ri";
import { BrazilianProduct } from "../../../@types/WalletB3";
import Skeleton from "react-loading-skeleton";
import { Spinner } from "react-bootstrap";
import IconBadge from "../IconBadge";
import Typewriter from "typewriter-effect";
import GradientText from "../../Logo";
import { IoSparklesOutline } from "react-icons/io5";

type Props = {
    product: BrazilianProduct;
    isAdditionalDataPresent: boolean;
    stockIconColor: string;
}
export default function StockProfileCard({ product, isAdditionalDataPresent, stockIconColor }: Props) {
    if (!isAdditionalDataPresent) {
        return <div
            className="tickets-card row cursor-default"
        >
            <div className="tickets-details col-lg-12">
                <div className="wrapper">
                    <div
                        className="img-xs rounded-circle"
                    >
                        <RiStockFill size={20} color="#f2f542" />
                    </div>
                    <h5>{product.name}</h5>
                </div>

                <div className="row flex-column">
                    <div className="col-12">
                        Ticker:{" "}
                        <div
                            className="badge badge-pill badge-secondary"
                            style={{ marginLeft: 0 }}
                        >
                            {product.ticker}
                        </div>
                    </div>

                    <div className="col-12">
                        Quantidade:{" "}
                        <div
                            className="badge badge-pill badge-secondary"
                            style={{ marginLeft: 0 }}
                        >
                            {product.qnt}
                        </div>
                    </div>

                    <div className="col-12">
                        A IA está pensando... <Spinner size="sm" animation="border" />
                        <Skeleton count={3} />
                    </div>
                </div>
            </div>

        </div>
    }

    return (
        <div
            className="tickets-card row cursor-default"
        >
            <div className="tickets-details col-lg-12">
                <div className="wrapper">
                    <div
                        className="img-xs rounded-circle"
                    >
                        <RiStockFill size={20} color={stockIconColor} />
                    </div>
                    <h5>{product.name}</h5>
                </div>

                <div className="row flex-column">
                    <div className="col-12">
                        Ticker:{" "}
                        <div
                            className="badge badge-pill badge-secondary"
                            style={{ marginLeft: 0 }}
                        >
                            {product.ticker}
                        </div>
                    </div>

                    <div className="col-12">
                        Quantidade:{" "}
                        <div
                            className="badge badge-pill badge-secondary"
                            style={{ marginLeft: 0 }}
                        >
                            {product.qnt}
                        </div>
                    </div>

                    {product.ai_result && <>
                        <div className="col-12">
                            <IconBadge icon={product.ai_result.icon} />

                        </div>

                        <div className="col-12 mg-t-10">
                            <div>
                                <GradientText text={"Cotação atual"} />
                                <IoSparklesOutline
                                    style={{ color: "var(--primary-blue)" }}
                                    size={25}
                                />
                            </div>
                            {
                                <Typewriter
                                    onInit={(typewriter) => {
                                        typewriter.typeString(
                                            product.ai_result.price_avaliation
                                        );

                                        typewriter.start();
                                    }}
                                    options={{
                                        delay: 1,
                                        cursorClassName: "d-none",
                                    }}
                                />
                            }

                        </div>

                        <div className="col-12 mg-t-10">
                            <div>
                                <GradientText text={"Resumo da IA"} />
                                <IoSparklesOutline
                                    style={{ color: "var(--primary-blue)" }}
                                    size={25}
                                />
                            </div>
                            {
                                <Typewriter
                                    onInit={(typewriter) => {
                                        typewriter.typeString(
                                            product.ai_result.ai_insight
                                        );

                                        typewriter.start();
                                    }}
                                    options={{
                                        delay: 1,
                                        cursorClassName: "d-none",
                                    }}
                                />
                            }

                        </div>


                    </>}

                </div>
            </div>

        </div>
    )
}